import * as React from 'react';
import { Form, FormInputProps } from 'semantic-ui-react';

interface Props extends FormInputProps {
    correo: string;
    requerido?: boolean;
    onChangeCorreo(correo: string): void;
}

const CorreoElectronico: React.FunctionComponent<Props> = props => {
    const { correo, requerido = false, onChangeCorreo, ...resto } = props;

    return (
        <Form.Input
            label='Correo electrónico'
            type='email'
            placeholder='ejemplo@mail.com'
            required={requerido}
            value={correo}
            onChange={(_e, { value }) => {
                onChangeCorreo(value.replace(/\s/g, '').toLowerCase());
            }}
            {...resto}
        />
    );
};

export default CorreoElectronico;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/CorreosElectronicos/componentes/CorreoElectronico.tsx